import axios from "axios";
import * as services from "redux/services";
import { showToast, TOAST_TYPE } from "utils/toast";
import store from "redux/store";
import { LOGOUT_SUCCESS } from "redux/constants";

// Scoped instance — attaching the interceptor to the global `axios` object would
// apply it to every consumer of the axios module, not just requests made here.
const client = axios.create();

client.interceptors.response.use(
  (response) => response,
  (error) => {
    // Dev bypass has no real token, so every authenticated call 401s by
    // design — don't let that log the fake session back out.
    if (error?.response?.status === 401 && process.env.REACT_APP_DEV_BYPASS !== "true") {
      services.removeLoginUser();
      // Update auth state instead of a hard reload — App.js's routing already
      // sends unauthenticated users to /auth/login (and preserves the page
      // they were on via SaveAndRedirect) once isAuth flips to false.
      store.dispatch({ type: LOGOUT_SUCCESS });
    }
    if (error?.response?.status === 403) {
      showToast("You don't have permission to access this resource.", TOAST_TYPE.error);
    }
    return Promise.reject(error);
  }
);

export const headers = {
  Accept: "application/json",
};

export const contentHeader = {
  "Content-Type": "application/json",
};

export const clientRequest = (method, url, data, customHeader) => {
  const token = `Bearer ${services.getToken()}`;
  return client({
    headers: { ...headers, ...customHeader, Authorization: token },
    method,
    url,
    data,
  });
};

export const clientImageRequest = async (method, url, data, customHeader, responseType) => {
  const token = `Bearer ${services.getToken()}`;
  return client({
    headers: { ...headers, ...customHeader, Authorization: token },
    method,
    url,
    data,
    responseType,
  });
};